import React, { useMemo } from "react";
import { useForm } from "react-hook-form";

import useTranslations from "../../../hooks/useTranslations";

import { FormStepProps } from "../../../screens/ReviewFormScreen";

import { Button, ScreenHeader } from "../../wombat-ui";
import { ArrowRightIcon, ReviewIcon } from "../../icons";

import ReviewConfigurationForm from "./ReviewConfigurationForm";

type NextStepButtonControlProps = Pick<FormStepProps, "onNext"> & {
  formState: ReturnType<typeof useForm>["formState"];
  disabled?: boolean;
};

const NextStepButtonControl: React.FC<NextStepButtonControlProps> = React.memo(
  ({ formState, onNext, disabled = false }) => {
    const t = useTranslations();
    const hasFormError = useMemo(() => {
      return formState.errors.startDate !== undefined;
    }, [formState]);

    return (
      <Button
        disabled={
          hasFormError ||
          disabled ||
          formState.isSubmitting ||
          formState.isSubmitted
        }
        type="button"
        id="nextStep"
        onClick={onNext}
        trailingIcon={ArrowRightIcon}
      >
        {t("forms.actions.next")}
      </Button>
    );
  }
);

const ThirdStep: React.FC<Omit<FormStepProps, "trigger">> = ({
  onNext,
  ...restProps
}) => {
  const t = useTranslations();

  return (
    <>
      <ScreenHeader
        icon={ReviewIcon}
        title={t("reviews.new")}
        description={t("reviews.launch")}
        actions={[
          <NextStepButtonControl
            formState={restProps.formState}
            onNext={onNext}
            key="next"
          />,
        ]}
      />
      <ReviewConfigurationForm {...restProps} />
    </>
  );
};

export default React.memo(ThirdStep);
